import { Tag, Typography } from 'antd';

const { Text } = Typography;

interface JiraIssueLinkProps {
  jiraKey: string;
  summary?: string | null;
  compact?: boolean;
}

export function JiraIssueLink({
  jiraKey,
  summary = null,
  compact = false,
}: JiraIssueLinkProps): JSX.Element {
  const href = `/api/jira/issues/${encodeURIComponent(jiraKey)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        color: 'inherit',
        textDecoration: 'none',
        maxWidth: '100%',
      }}
    >
      <Tag color="blue" style={{ margin: 0, fontSize: compact ? 11 : undefined }}>
        {jiraKey}
      </Tag>
      {!compact && summary && (
        <Text
          style={{
            color: 'inherit',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {summary}
        </Text>
      )}
    </a>
  );
}
